import React from 'react';

type Sponsor = {
  name: string;
  logo: string;
};

const sponsors: Sponsor[] = [
  { name: 'Sponsor 1', logo: '/img/sponsor1.png' },
  { name: 'Sponsor 2', logo: '/img/sponsor2.png' },
  { name: 'Sponsor 3', logo: '/img/sponsor3.png' },
  { name: 'Sponsor 4', logo: '/img/sponsor4.png' },
  { name: 'Sponsor 5', logo: '/img/sponsor5.png' },
  { name: 'Sponsor 6', logo: '/img/sponsor6.png' },
];

export const Footer: React.FC = () => {
    return (
        <footer style={styles.footer}>
        {/* Sección de Sponsors */}
        <div style={styles.sponsorsSection}>
            <h3 style={styles.title}>Nuestros Sponsors</h3>
            <div style={styles.sponsorsContainer}>
            {sponsors.map((sponsor, index) => (
                <div key={index} style={styles.sponsorCard}>
                <img src={sponsor.logo} alt={sponsor.name} style={styles.sponsorLogo} />
                </div>
            ))}
            </div>
        </div>

        {/* Sección de Información */}
        <div style={styles.infoSection}>
            <div style={styles.infoGroup}>
            <h4 style={styles.infoTitle}>Información de Contacto</h4>
            <p>📍 Dirección: Sarmiento 227 - Famaillá - Argentina</p>
            <p>📞 Teléfono: +54 381 31 91999</p>
            <p>📧 Email: clubatleticofamailla@gmail.com</p>
            </div>
            <div style={styles.infoGroup}>
            <h4 style={styles.infoTitle}>Redes Sociales</h4>
            <p>
                <a href="https://www.facebook.com/elfama1908/?locale=es_LA" target="_blank" style={styles.socialLink}>Facebook</a> |{' '}
                <a href="https://www.instagram.com/clubatleticofamailla_oficial/" target="_blank" style={styles.socialLink}>Instagram</a> |{' '}
                <a href="https://twitter.com" target="_blank" style={styles.socialLink}>Twitter</a>
            </p>
            </div>
            <div style={styles.infoGroup}>
            <h4 style={styles.infoTitle}>Horario de Atención</h4>
            <p>Lunes a Viernes: 9:00 AM - 6:00 PM</p>
            <p>Sábado: 9:00 AM - 1:00 PM</p>
            <p>Domingo: Cerrado</p>
            </div>
        </div>
        </footer>
    );
};

// Estilos tipados
const styles: { [key: string]: React.CSSProperties } = {
    footer: {
        background: 'linear-gradient(90deg, #179661, #0AA6E3)',
        color: '#fff',
        padding: '20px 40px',
        textAlign: 'center',
    },
    sponsorsSection: {
        marginBottom: '30px',
    },
    title: {
        fontSize: '24px',
        marginBottom: '15px',
        color: '#fff',
    },
    sponsorsContainer: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        gap: '20px',
    },
    sponsorCard: {
        width: '120px',
        height: '60px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#fff',
        borderRadius: '8px',
        overflow: 'hidden',
        boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
    },
    sponsorLogo: {
        width: '100%',
        height: 'auto',
    },
    infoSection: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        gap: '20px',
        borderTop: '1px solid rgba(255, 255, 255, 0.5)',
        paddingTop: '20px',
    },
    infoGroup: {
        flex: '1 1 200px',
        textAlign: 'left',
    },
    infoTitle: {
        fontSize: '18px',
        marginBottom: '10px',
        color: '#FFF',
    },
    socialLink: {
        color: '#FFF',
        textDecoration: 'none',
    },
};
